export default __webpack_public_path__ + "static/1739-6b89edd4a7b9cead57d6ec43181ad829.gif";